import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import Settings from './Settings';
import Auth from './Auth';
import Reports from './Reports';
import General from './General';

const reducers = combineReducers({
	routing: routerReducer,
	settings: Settings,
	auth: Auth,
	reports: Reports,
	general: General
});

export default reducers;



// WEBPACK FOOTER //
// ./reducers/index.js